import React from "react";
import { Link } from "react-router-dom";

export default function BusinessFunctions() {
  return (
    <div className="container section">
      <div className="pageHero">
        <div className="pageHeroText">
          <span className="eyebrow">How we operate</span>
          <div className="pageHeroTitle">Services & business functions</div>
          <p className="pageHeroSub">
            Rahisi combines a consumer shopping app, a merchant platform, and a rider network —
            all coordinated through a single, structured digital infrastructure.
          </p>
        </div>
      </div>

      <img src="/tablet_bg_7.png" alt="Rahisi operations" className="pageBanner" />

      <div className="featuresGrid">
        {[
          {
            icon: "🛒",
            title: "Customer retail access",
            desc: "Product catalogue browsing, category filtering, search, wishlists, and a cart-to-checkout flow with M-Pesa and card payments.",
          },
          {
            icon: "🚴",
            title: "Rider & delivery network",
            desc: "On-demand delivery partners accept, navigate, and complete orders tracked in real time. Earnings are visible and updated instantly.",
          },
          {
            icon: "🏪",
            title: "Merchant & inventory tools",
            desc: "Merchants manage product listings, stock levels, pricing, promotions, and flash deals through a structured admin interface.",
          },
          {
            icon: "📊",
            title: "Analytics & reporting",
            desc: "Operational dashboards cover order volumes, rider activity, product performance, and customer engagement — all in real time.",
          },
          {
            icon: "🏷️",
            title: "Promotions & deals engine",
            desc: "Flash deals with countdown timers, promo codes, hero banners, and deal-of-the-day features drive engagement and repeat purchase.",
          },
          {
            icon: "🔒",
            title: "Governance & compliance",
            desc: "Data minimisation, access controls, audit logging, and publicly published policies keep operations transparent and accountable.",
          },
        ].map((f) => (
          <div className="featureCard" key={f.title}>
            <div className="featureCardIcon">{f.icon}</div>
            <div className="featureCardTitle">{f.title}</div>
            <p className="featureCardDesc">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="stepsGrid" style={{ marginTop: "48px" }}>
        <div className="step">
          <div className="stepNum">🛍️</div>
          <div className="stepTitle">Customer journey</div>
          <p className="stepDesc">Download → browse → add to cart → pay with M-Pesa → receive at door → track return if needed.</p>
        </div>
        <div className="step">
          <div className="stepNum">🚴</div>
          <div className="stepTitle">Rider journey</div>
          <p className="stepDesc">Sign up → accept order → navigate with live map → complete delivery → view earnings instantly.</p>
        </div>
        <div className="step">
          <div className="stepNum">🏪</div>
          <div className="stepTitle">Merchant journey</div>
          <p className="stepDesc">Onboard → list products → set pricing → manage inventory → run promotions → track performance.</p>
        </div>
      </div>

      <div className="inlineLinks" style={{ marginTop: "40px" }}>
        <Link to="/our-app">Explore the app</Link>
        <span className="dot">•</span>
        <Link to="/governance">Governance</Link>
        <span className="dot">•</span>
        <Link to="/contact">Get in touch</Link>
      </div>
    </div>
  );
}
